import { NgModule } from '@angular/core';
import { AuthGuard } from '../core/auth.guard';
import { AuthService } from '../core/auth.service';
import { FirebaseAuthModule } from '../firebase/firebase-auth.module';
import { OidcClientModule } from '../oidc-client/oidc-client.module';
import { CustomAuthGuard } from './custom-auth.guard';
import { CustomAuthService } from './custom-auth.service';

@NgModule({
  providers: [
    CustomAuthService,
    CustomAuthGuard,
    { provide: AuthService, useClass: CustomAuthService },
    { provide: AuthGuard, useClass: CustomAuthGuard },
  ],
  declarations: [],
  imports: [OidcClientModule, FirebaseAuthModule],
})
export class CustomAuthModule { }
